import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { format } from 'fecha'
import React, { useEffect, useState } from 'react'
import toUpperCamelCase from '../../../view-model/Funciones/toUpperCamelCase'
import { useHistory, useLocation } from 'react-router-dom';
// import IViewAsegurado from '../../../view-interfaces/IViewAsegurado'
import IViewAsegurado from '../../../view-interfaces/IViewTipoPersona';
import IViewGeneroCmb from '../../../view-interfaces/IViewGeneroCmb';
import IViewComunasAuto from '../../../view-interfaces/IViewComunasAuto'
import IViewPaisNacionalidadCmb from '../../../view-interfaces/IViewPaisNacionalidadCmb';

import { RequisitosAsegurado } from '../../../view-model/Modals/RequisitosAsegurado'

import IViewResultado from "../../../view-interfaces/IViewResultado";
import { ObtieneDatosPersonalesLogic, GrabarDatosPersonalesLogic, BloqueoPorRutLogic } from '../../../view-model/DatosPersonales/DatosPersonales.logic';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken'


type Props = {
    codigoNegocio: number;
    rutPostulante: number;
    carrera: string;
    anioPromocion: number;
    periodoPromocion: number;
    asegurado: IViewAsegurado[];
    listaGenero: IViewGeneroCmb[];
    listaComunas: IViewComunasAuto[];
    listaPaisNacionalidad: IViewPaisNacionalidadCmb[];
    callback: any;
    validar: boolean;
    guardar: boolean;
}

export const Asegurado: React.FC<Props> = ({ codigoNegocio, rutPostulante, carrera, anioPromocion, periodoPromocion, asegurado, listaGenero, listaComunas, listaPaisNacionalidad, callback, validar, guardar }) => {
    const location = useLocation();

    const [maxFecha, setMaxFecha] = useState('');

    const { validarRUT } = require('validar-rut')
    const [estiloRut, setEstiloRut] = useState('form-control js-rut js-will-validate');
    const { formatterRut, cleanRut } = require('chilean-formatter');
    const [rutCompleto, setRutCompleto] = useState('');
    const [rut, setRut] = useState(0);
    const [nombres, setNombres] = useState('');
    const [apPaterno, setApPaterno] = useState('');
    const [apMaterno, setApMaterno] = useState('');
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [direccion, setDireccion] = useState('');
    const [telefono, setTelefono] = useState(0);
    const [mail, setMail] = useState('');

    const _listGenero: IViewGeneroCmb = { ID: 0, descripcion: '' };
    const [valGenero, setValGenero] = useState(_listGenero);
    const [codSexo, setCodSexo] = useState(0);
    const [sexo, setSexo] = useState('');

    const _listComuna: IViewComunasAuto = { ID: 0, descripcion: '' };
    const [valComuna, setValComuna] = useState(_listComuna);
    const [codComuna, setCodComuna] = useState(0);
    const [comuna, setComuna] = useState('');

    const _listPaisNacionalidad: IViewPaisNacionalidadCmb = { ID: 0, descripcion: '' };
    const [valPaisNacionalidad, setValPaisNacionalidad] = useState(_listPaisNacionalidad);
    const [idPais, setIdPais] = useState(0);
    const [nacionalidad, setNacionalidad] = useState('');

    const [personaEncontrada, setPersonaEncontrada] = useState(false);
    const [openModalRequisitos, setOpenModalRequisitos] = useState(false);

    //const [mjeErrorAlerta, setMjeErrorAlerta] = useState('');
    const [error, setError] = useState(true);
    //const [validado, setValidado] = useState(false);
    //const [guardado, setGuardado] = useState(false);
    const [bloqueoDatos, setBloqueoDatos] = useState(false);

    const listaResultado: Array<IViewResultado> = [];
    const [listParams, setlistParams] = useState(listaResultado);
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
    const [codNegocio, setCodNegocio] = useState(0)
    const handleRequisitos = () => {
        setOpenModalRequisitos(true);
    }

    const handleCerrarPopUpRequisitos = (paso: Boolean = false) => {
        if (paso) {
        }
        setOpenModalRequisitos(false);
    }

    const handleSelectGenero = (event: any, newValue: any) => {
        if (newValue !== null) {
            setCodSexo(newValue.ID);
            setSexo(newValue.descripcion);
            setValGenero(newValue);
        }
    }

    const handleSelectComuna = (event: any, newValue: any) => {
        if (newValue !== null) {
            setCodComuna(newValue.ID);
            setComuna(newValue.descripcion);
            setValComuna(newValue);
        }
    }

    const handleSelectPaisNacionalidad = (event: any, newValue: any) => {
        if (newValue !== null) {
            setIdPais(newValue.ID);
            setNacionalidad(newValue.descripcion);
            setValPaisNacionalidad(newValue);
        }
    }

    useEffect(() => {
        if (guardar) {
            handleValidarDatos();
            //handleGrabarDatos()
        }
    }, [guardar])

    useEffect(() => {
        if (error === false) {
            handleGrabarDatos();
            setError(true);
        }
    }, [error])

    const handleCargaDatos = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        setCodNegocio(_params.headers.codNegocio)
        var fecha = new Date()
        var dd = fecha.getDate();
        var mm = fecha.getMonth() + 1;
        var yyyy = fecha.getFullYear();

        setMaxFecha((yyyy) + '-' + (mm.toString().length === 1 ? ('0' + (mm).toString()) : (mm)) + '-' + (dd.toString().length === 1 ? ('0' + dd.toString()) : dd))
        if (asegurado.length > 0 && asegurado[0].run > 0) {

            BloqueoPorRutLogic(selBloqueoPorRut, rutPostulante, codigoNegocio, carrera,
                anioPromocion, periodoPromocion, 0, asegurado[0].run);

            setRutCompleto(asegurado[0].runFormato);
            setRut(asegurado[0].run);
            setNombres(asegurado[0].nombres);
            setApPaterno(asegurado[0].primerApellido);
            setApMaterno(asegurado[0].segundoApellido);
            let _fecha = format(new Date(asegurado[0].fechaNacimiento), 'YYYY-MM-DD') === '1900-01-01' ? '' : format(new Date(asegurado[0].fechaNacimiento), 'YYYY-MM-DD');
            setFechaNacimiento(_fecha);
            setDireccion(asegurado[0].direccion);
            setTelefono(asegurado[0].telefono);
            setMail(asegurado[0].email);

            setCodSexo(asegurado[0].codSexo);
            setSexo(asegurado[0].sexo);
            setCodComuna(asegurado[0].codigoComuna);
            setComuna(asegurado[0].nombreComuna);
            setIdPais(asegurado[0].idPais);
            setNacionalidad(asegurado[0].nacionalidad);

            if (listaGenero.length > 0) {
                let _genero = listaGenero.find(gen => gen.ID === asegurado[0].codSexo);
                setValGenero({
                    ID: (_genero?.ID !== undefined ? _genero.ID : 0),
                    descripcion: (_genero?.descripcion !== undefined ? _genero.descripcion : '')
                });
            }
            if (listaComunas.length > 0) {
                let _comuna = listaComunas.find(com => com.ID === asegurado[0].codigoComuna);
                setValComuna({
                    ID: (_comuna?.ID !== undefined ? _comuna.ID : 0),
                    descripcion: (_comuna?.descripcion !== undefined ? _comuna.descripcion : '')
                });
            }
            if (listaPaisNacionalidad.length > 0) {
                let _paisNacionalidad = listaPaisNacionalidad.find(com => com.ID === asegurado[0].idPais);
                setValPaisNacionalidad({
                    ID: (_paisNacionalidad?.ID !== undefined ? _paisNacionalidad.ID : 0),
                    descripcion: (_paisNacionalidad?.descripcion !== undefined ? _paisNacionalidad.descripcion : '')
                });
            }
        }
    }

    function calcularAños() {
        /*  var today = new Date();
         var birthday = new Date(fechaNacimiento);
         //Restamos los años
         let agno = today.getFullYear() - birthday.getFullYear();
         // Si no ha llegado su cumpleaños le restamos el año por cumplir
         if (birthday.getMonth() > today.getMonth() || (birthday.getDay() > today.getDay() && birthday.getMonth() === today.getMonth()))
             agno--; */

        /* console.log(fechaNacimiento) */
        let hoy = new Date()
        let birthday = new Date(fechaNacimiento + " 00:00:000")
        /* console.log(hoy)
        console.log(birthday) */
        let agno = hoy.getFullYear() - birthday.getFullYear()
        let diferenciaMeses = hoy.getMonth() - birthday.getMonth()
        if (
            diferenciaMeses < 0 ||
            (diferenciaMeses === 0 && hoy.getDate() < birthday.getDate())
        ) {
            agno--
        }
        /* console.log(agno) */
        return agno;
    }

    const handleValidarDatos = () => {
        let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        //var today = new Date();
        try {
            if (rutCompleto === "" || rutCompleto === undefined) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar el nombre.");
                callback(false, "Debe ingresar un Rut.");
            } else if ((nombres === "" || nombres === undefined) && personaEncontrada === false) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar el nombre.");
                callback(false, "Debe ingresar el nombre.");
            } else if ((apPaterno === "" || apPaterno === undefined) && personaEncontrada === false) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar el primer apellido.");
                callback(false, "Debe ingresar el primer apellido.");
            }
            else if ((apMaterno === "" || apMaterno === undefined) && personaEncontrada === false) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar el segundo apellido.");
                callback(false, "Debe ingresar el segundo apellido.");
            }
            // else if ((rutCompleto === "" || rutCompleto === undefined) && personaEncontrada === false)
            // {
            //     setError(true);
            //     //setMjeErrorAlerta(((today.getFullYear() - new Date(fechaNacimiento).getFullYear())).toString());
            //     callback(false,((today.getFullYear() - new Date(fechaNacimiento).getFullYear())).toString());
            // }
            else if (fechaNacimiento === "" || fechaNacimiento === undefined) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar la fecha de nacimiento.");
                callback(false, "Debe ingresar la fecha de nacimiento.");
            }
            else if (calcularAños() < 18) {
                setError(true);
                //setMjeErrorAlerta("El RF debe tener más de 18 años de edad. " + calcularAños().toString());
                callback(false, "El asegurado debe tener más de 18 años de edad.");//+ calcularAños().toString());
            }
            else if (calcularAños() > 69) {
                setError(true);
                //setMjeErrorAlerta("El RF debe tener más de 18 años de edad. " + calcularAños().toString());
                callback(false, "El asegurado debe tener menos de 70 años de edad.");//+ calcularAños().toString());
            }
            /* else if (idGenero === 0)
            {
                setError(true);
                //setMjeErrorAlerta("Debe seleccionar sexo.");
                callback(false,"Debe seleccionar sexo.");
            } */
            else if ((codComuna === 0 || codComuna === undefined) && bloqueoDatos === false) {
                setError(true);
                //setMjeErrorAlerta("Debe seleccionar una comuna.");
                callback(false, "Debe seleccionar una comuna.");
            }
            else if ((direccion === "" || direccion === undefined) && bloqueoDatos === false) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar la dirección.");
                callback(false, "Debe ingresar la dirección.");
            }
            else if (direccion.length < 3) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar la dirección.");
                callback(false, "Debe ingresar la dirección.");
            }
            else if (telefono === 0 || telefono === undefined) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar el teléfono.");
                callback(false, "Debe ingresar el teléfono.");
            }
            else if (telefono.toString().length !== 9) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar teléfono correctamente.");
                callback(false, "Debe ingresar teléfono correctamente.");
            }
            else if (mail === "" || mail === undefined) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar el Email.");
                callback(false, "Debe ingresar el Email.");
            }
            else if (!regEmail.test(mail)) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar un Email válido.");
                callback(false, "Debe ingresar un Email válido.");
            }
            else if (idPais === 0) {
                setError(true);
                //setMjeErrorAlerta("Debe seleccionar la nacionalidad.");
                callback(false, "Debe seleccionar la nacionalidad.");
            }
            else {
                setRut(cleanRut(rutCompleto, false));

                setError(false);
                //setValidado(true);
                callback(true)
            }
        } catch (e: any) {
            setError(true);
            //setMjeErrorAlerta("Debe seleccionar la nacionalidad.");
            callback(false, "Ocurrio un error al validar sus datos.");
        }
    }

    const handleBuscarPersona = () => {
        // ObtienePersonaLogic(selListaPersona, cleanRut(rutCompleto, false));
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (rutCompleto.length > 8)
            ObtieneDatosPersonalesLogic(selListaPersona, _params.headers, cleanRut(rutCompleto, false), "", codigoNegocio, 0);
    }

    const selListaPersona = (error: Boolean, err: string, Persona: any) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        try {
            if (error === false) {
                if (_params.rut !== Persona[0].run) {
                    if (error === false && Persona[0].run.toString().length > 1) {
                        setPersonaEncontrada(true);

                        BloqueoPorRutLogic(selBloqueoPorRut, rutPostulante, codigoNegocio, carrera,
                            anioPromocion, periodoPromocion, 0, Persona[0].run);

                        setRutCompleto(Persona[0].runFormato);
                        setRut(Persona[0].run);
                        setNombres(Persona[0].nombres);
                        setApPaterno(Persona[0].primerApellido);
                        setApMaterno(Persona[0].segundoApellido);

                        let _fecha = format(new Date(Persona[0].fechaNacimiento), 'YYYY-MM-DD') === '1900-01-01' ? '' : format(new Date(Persona[0].fechaNacimiento), 'YYYY-MM-DD');
                        setFechaNacimiento(_fecha);
                        setDireccion(Persona[0].direccion);
                        setTelefono(Persona[0].telefono);
                        setMail(Persona[0].email);

                        setCodSexo(Persona[0].codSexo);
                        setSexo(Persona[0].sexo);
                        setCodComuna(Persona[0].codigoComuna);
                        setComuna(Persona[0].nombreComuna);
                        setIdPais(Persona[0].idPais);
                        setNacionalidad(Persona[0].nacionalidad);

                        if (listaGenero.length > 0) {
                            let _genero = listaGenero.find(gen => gen.ID === Persona[0].codSexo);
                            setValGenero({
                                ID: (_genero?.ID !== undefined ? _genero.ID : 0),
                                descripcion: (_genero?.descripcion !== undefined ? _genero.descripcion : '')
                            });
                        }
                        if (listaComunas.length > 0) {
                            let _comuna = listaComunas.find(com => com.ID === Persona[0].codigoComuna);
                            setValComuna({
                                ID: (_comuna?.ID !== undefined ? _comuna.ID : 0),
                                descripcion: (_comuna?.descripcion !== undefined ? _comuna.descripcion : '')
                            });
                        }
                        if (listaPaisNacionalidad.length > 0) {
                            let _paisNacionalidad = listaPaisNacionalidad.find(com => com.ID === Persona[0].idPais);
                            setValPaisNacionalidad({
                                ID: (_paisNacionalidad?.ID !== undefined ? _paisNacionalidad.ID : 0),
                                descripcion: (_paisNacionalidad?.descripcion !== undefined ? _paisNacionalidad.descripcion : '')
                            });
                        }
                    }
                    else {
                        setPersonaEncontrada(false);
                        setBloqueoDatos(false);

                        setRutCompleto('');
                        setNombres('');
                        setApPaterno('');
                        setApMaterno('');
                        setFechaNacimiento('');
                        setDireccion('');
                        setTelefono(0);
                        setMail('');

                        setCodSexo(0);
                        setSexo('');
                        setCodComuna(0);
                        setComuna('');
                        setIdPais(0);
                        setNacionalidad('');
                        if (listaGenero.length > 0) {
                            let _genero = listaGenero.find(gen => gen.ID === Persona[0].codSexo);
                            setValGenero({
                                ID: (_genero?.ID !== undefined ? _genero.ID : 0),
                                descripcion: (_genero?.descripcion !== undefined ? _genero.descripcion : '')
                            });
                        }
                        if (listaComunas.length > 0) {
                            let _comuna = listaComunas.find(com => com.ID === Persona[0].codigoComuna);
                            setValComuna({
                                ID: (_comuna?.ID !== undefined ? _comuna.ID : 0),
                                descripcion: (_comuna?.descripcion !== undefined ? _comuna.descripcion : '')
                            });
                        }
                        if (listaPaisNacionalidad.length > 0) {
                            let _paisNacionalidad = listaPaisNacionalidad.find(com => com.ID === Persona[0].idPais);
                            setValPaisNacionalidad({
                                ID: (_paisNacionalidad?.ID !== undefined ? _paisNacionalidad.ID : 0),
                                descripcion: (_paisNacionalidad?.descripcion !== undefined ? _paisNacionalidad.descripcion : '')
                            });
                        }
                        callback(false, 'Rut no existe en nuestros registro.', false)
                    }
                }
                else {
                    setPersonaEncontrada(false);
                    setBloqueoDatos(false);

                    setRutCompleto('');
                    setNombres('');
                    setApPaterno('');
                    setApMaterno('');
                    setFechaNacimiento('');
                    setDireccion('');
                    setTelefono(0);
                    setMail('');

                    setCodSexo(0);
                    setSexo('');
                    setCodComuna(0);
                    setComuna('');
                    setIdPais(0);
                    setNacionalidad('');
                    if (listaGenero.length > 0) {
                        let _genero = listaGenero.find(gen => gen.ID === Persona[0].codSexo);
                        setValGenero({
                            ID: (_genero?.ID !== undefined ? _genero.ID : 0),
                            descripcion: (_genero?.descripcion !== undefined ? _genero.descripcion : '')
                        });
                    }
                    if (listaComunas.length > 0) {
                        let _comuna = listaComunas.find(com => com.ID === Persona[0].codigoComuna);
                        setValComuna({
                            ID: (_comuna?.ID !== undefined ? _comuna.ID : 0),
                            descripcion: (_comuna?.descripcion !== undefined ? _comuna.descripcion : '')
                        });
                    }
                    if (listaPaisNacionalidad.length > 0) {
                        let _paisNacionalidad = listaPaisNacionalidad.find(com => com.ID === Persona[0].idPais);
                        setValPaisNacionalidad({
                            ID: (_paisNacionalidad?.ID !== undefined ? _paisNacionalidad.ID : 0),
                            descripcion: (_paisNacionalidad?.descripcion !== undefined ? _paisNacionalidad.descripcion : '')
                        });
                    }
                    // setError(true);
                    // setMjeErrorAlerta('Rut no existe en nuestros registro.');
                    callback(false, 'El Alumno no puede ser Asegurado.', false)
                    // setError(true);
                    // setMjeErrorAlerta('Rut no existe en nuestros registro.');
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const handleGrabarDatos = () => {
        if (error === false) {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            callback(false, "Guardando...", false)
            GrabarDatosPersonalesLogic(selResultadoParametros, _params.headers, 0, rutCompleto, "", nombres, apPaterno, apMaterno, new Date(fechaNacimiento),
                codComuna, comuna, direccion, telefono, mail, codSexo, sexo, idPais, nacionalidad, idPais, nacionalidad,
                rutPostulante, codigoNegocio, carrera, anioPromocion, periodoPromocion, 0, 3);
        }
    }

    const selBloqueoPorRut = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false && Resultado !== undefined) {
                setBloqueoDatos(Resultado);
                if (Resultado === true) {
                    setPersonaEncontrada(true);
                }
            }
        } catch (err) {
            setBloqueoDatos(false);
        }
    }

    const selResultadoParametros = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false && Resultado !== undefined) {
                setlistParams(Resultado);
                callback(false, "Guardando...", false)
                setTimeout(() => {
                    callback(false, "Se ha guardado correctamente la información.", true)
                }, 5000);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (err) {
            callback(false, "Ocurrió un error al guardar la información.", true)
            console.log('error', err);
        }
    }

    useEffect(() => {
        handleCargaDatos();
    }, []);

    useEffect(() => {
        if (rutCompleto !== "" && rutCompleto !== undefined) {
            if (rutCompleto.trim().length > 7 && rutCompleto.trim().length <= 13) {
                if (validarRUT(rutCompleto.trim())) {
                    setRutCompleto(formatterRut(rutCompleto.trim()));
                    setEstiloRut("form-control js-rut js-will-validate is-valid");
                    //setDisableBotonIngresar(false);
                    callback(false, '', false);
                }
                else {
                    setEstiloRut("form-control js-rut js-will-validate is-invalid")
                    callback(false, 'Error en formato de rut', false);
                }
            }
            if (rutCompleto.trim().length < 7) {
                callback(false, 'Error en formato de rut', false);
                setEstiloRut('form-control js-rut js-will-validate');
            }
        }
    }, [rutCompleto]);

    useEffect(() => {
        //setValidado(false)
        callback(false, '', false);
        //setError(true)
    }, [rut, nombres, apMaterno, apPaterno, fechaNacimiento, direccion, codSexo, codComuna, telefono, mail, nacionalidad]);

    return (
        <>
            <div className="personal-information__content tab-content" id="nav-tabContent">
                <div className="tab-pane fade show active" id="insured" role="tabpanel" aria-labelledby="insured-tab">
                    <h3 className="personal-information__content-title">Datos del Asegurado</h3>
                    <p style={{ fontSize: 12 }}>Se refiere al Padre, Madre o Tutor que sustenta económicamente las colegiaturas del alumno, quien debe cumplir con los requisitos de edad exigidos por la póliza. Si el sostenedor económico no cumple con los requisitos de edad, puede asegurar a otra persona.</p>
                    <ul>
                        <li>
                            <button type="button"
                                className="btn btn-link"
                                onClick={handleRequisitos}>
                                Ver requisitos
                            </button>
                        </li>
                    </ul>

                    <form id="form-insured" className="personal-information__form">
                        {/* <div className="custom-control custom-checkbox personal-information__same-insured">
                        <input id="copy-person-data" className="custom-control-input" type="checkbox" />
                        <label htmlFor="copy-person-data" className="custom-control-label">El Asegurado será la misma persona que el Responsable Financiero</label>
                    </div> */}
                        <div className="form-content" id="form-content-insured">
                            <div className="form-group">
                                <label htmlFor="rutfinancialmanager">RUT <span className="required">*</span></label>
                                <input id="rutfinancialmanager"
                                    name="rut"
                                    placeholder="99999999-9"
                                    max={13}
                                    maxLength={13}
                                    onBlur={handleBuscarPersona}
                                    className={estiloRut}
                                    type="text"
                                    value={rutCompleto}
                                    onChange={(e: any) => setRutCompleto(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="firstnameinsured">Nombres <span className="required">*</span></label>
                                <input id="firstnameinsured"
                                    name="firstname"
                                    className="form-control js-will-validate"
                                    type="text"
                                    disabled={personaEncontrada}
                                    onChange={(e: any) => setNombres(e.target.value)}
                                    value={nombres} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="firstlastnameinsured">Primer Apellido <span className="required">*</span></label>
                                <input id="firstlastnameinsured"
                                    name="firstlastname"
                                    className="form-control js-will-validate"
                                    type="text"
                                    disabled={personaEncontrada}
                                    onChange={(e: any) => setApPaterno(e.target.value)}
                                    value={apPaterno} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="secondlastnameinsured">Segundo Apellido <span className="required">*</span></label>
                                <input id="secondlastnameinsured"
                                    name="secondlastname"
                                    className="form-control js-will-validate"
                                    type="text"
                                    disabled={personaEncontrada}
                                    onChange={(e: any) => setApMaterno(e.target.value)}
                                    value={apMaterno} />
                            </div>
                            {/* <div className="form-group">
                            <label htmlFor="rutinsured">Rut <span className="required">*</span></label>
                            <input 
                                id="rutinsured" 
                                name="rut" 
                                className="form-control js-rut js-will-validate" 
                                type="text" 
                                onChange={(e:any) => setRut(e.target.value)}
                                value={rut} />
                        </div> */}
                            <div className="form-group">
                                <label htmlFor="birthdateinsured">Fecha de Nacimiento <span className="required">*</span></label>
                                <input id="birthdateinsured"
                                    name="birthdate"
                                    className="form-control js-will-validate"
                                    type="date"
                                    pattern="[0-9]{2}-[0-9]{2}-[0-9]{4}"
                                    max={maxFecha}
                                    onChange={(e: any) => setFechaNacimiento(e.target.value)}
                                    value={fechaNacimiento} />
                            </div>
                            <div className="form-group form-group--genero">
                                <p>Sexo {/* <span className="required">*</span> */}</p>
                                <Autocomplete id="lstGenero"
                                    value={valGenero}
                                    options={listaGenero}
                                    noOptionsText={'No existe la opción.'}
                                    size='small'
                                    getOptionLabel={(options: {
                                        descripcion: string;
                                        ID: number;
                                    }) => toUpperCamelCase(options.descripcion)}
                                    onChange={handleSelectGenero}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            variant='outlined'
                                            placeholder="Seleccione Sexo"
                                            margin="normal"
                                            fullWidth
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password',
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group form-group--genero">
                                <p>Comuna <span className="required">*</span></p>
                                <Autocomplete id="lstComuna"
                                    value={valComuna}
                                    options={listaComunas}
                                    noOptionsText={'No existe la opción.'}
                                    size='small'
                                    disabled={bloqueoDatos}
                                    getOptionLabel={(options: {
                                        descripcion: string;
                                        ID: number;
                                    }) => toUpperCamelCase(options.descripcion)}
                                    onChange={handleSelectComuna}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            variant='outlined'
                                            placeholder="Seleccione Comuna"
                                            margin="normal"
                                            fullWidth
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password',
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group form-group--direccion">
                                <label htmlFor="addressinsured">Dirección <span className="required">*</span></label>
                                <input id="addressinsured"
                                    name="address"
                                    className="form-control js-will-validate"
                                    type="text"
                                    value={direccion}
                                    disabled={bloqueoDatos}
                                    onChange={(e: any) => setDireccion(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="mobile-phoneinsured">Celular <span className="required">*</span></label>
                                <div className="personal-information__phones">
                                    <span>+56</span>
                                    <input id="mobile-phoneinsured"
                                        name="mobile-phone"
                                        className="form-control js-mobile js-will-validate"
                                        type="text"
                                        pattern="[0-9]*"
                                        maxLength={9}
                                        max={9}
                                        value={telefono}
                                        onChange={(e: any) => setTelefono(e.target.value)}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="emailinsured">Email <span className="required">*</span></label>
                                <input id="emailinsured"
                                    name="email"
                                    className="form-control js-will-validate"
                                    type="email"
                                    onChange={(e: any) => setMail(e.target.value)}
                                    value={mail} />
                            </div>
                            {/* <div className="form-group">
                            <div className="form-group form-group--nationality">
                                <label htmlFor="nationality">Nacionalidad <span className="required">*</span></label>
                                <input 
                                    id="nationality"
                                    name="nationality"
                                    className="form-control select-nationality js-will-validate"
                                    type="text"
                                    value={nacionalidad}
                                    onChange={(e:any) => setNacionalidad(e.target.value)} />
                            </div>
                        </div> */}
                            <div className="form-group">
                                <div className="form-group form-group--nationality">
                                    <p>Nacionalidad <span className="required">*</span></p>
                                    <Autocomplete value={valPaisNacionalidad}
                                        options={listaPaisNacionalidad}
                                        size='small'
                                        getOptionLabel={(options: {
                                            descripcion: string;
                                            ID: number;
                                        }) => toUpperCamelCase(options.descripcion)}
                                        onChange={handleSelectPaisNacionalidad}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant='outlined'
                                                placeholder="Seleccione Nacionalidad"
                                                margin="normal"
                                                fullWidth
                                                inputProps={{
                                                    ...params.inputProps,
                                                    autoComplete: 'new-password',
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <div className="form-group submit-btn personal-information__submit">
                        <label htmlFor="">Ir a completar los datos de la Persona de Contacto</label>
                        <button className="btn btn-primary" id="btn-submit-insured" disabled type="submit">Siguiente</button>
                    </div> */}
                        {/* <Grid container spacing={0}>
                        <Button onClick={handleValidarDatos} disabled={validado} variant="contained" color="primary">Validar</Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button onClick={handleGrabarDatos} disabled={!validado} variant="contained" color="primary">Grabar</Button>
                        {error === true ?
                            <Alert severity="warning">{mjeErrorAlerta }</Alert>
                            : ''}
                        {guardado === true ?
                            <Alert severity="success">{mjeErrorAlerta }</Alert>
                            : ''}
                    </Grid> */}
                    </form>
                </div>
                <div>
                    <RequisitosAsegurado estado={openModalRequisitos} onClick={handleCerrarPopUpRequisitos} />
                </div>
            </div>
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>)
}